"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeNavigation_en_us = void 0;
function backofficeNavigation_en_us() {
    return {
        "backoffice.navigation.company": "Company",
        "backoffice.navigation.companysettings": "Company Settings",
        "backoffice.navigation.projectsettings": "Project Settings",
        "backoffice.navigation.invoices": "Invoices",
        "backoffice.navigation.projects": "Projects",
        "backoffice.navigation.overview": "Overview",
        "backoffice.navigation.internationalization": "Internationalization",
        "backoffice.navigation.localizations": "Localizations",
        "backoffice.navigation.languages": "Languages",
        "backoffice.navigation.cms": "CMS Pages",
        "backoffice.navigation.websites": "Websites",
        "backoffice.navigation.products": "Products",
        "backoffice.navigation.roles": "Roles",
        "backoffice.navigation.companyroles": "Company roles",
        "backoffice.navigation.companyrolessubtitle": "Roles of the company ",
        "backoffice.navigation.projectroles": "Project roles",
        "backoffice.navigation.projectrolessubtitle": "Roles of the project ",
        "backoffice.navigation.configuration": "Configuration",
        "backoffice.navigation.files": "Files",
        "backoffice.navigation.projectfiles": "Project Files",
        "backoffice.navigation.companyfiles": "Company Files",
        "backoffice.navigation.users": "Users",
        "backoffice.navigation.noproject": "No current projects",
        "backoffice.navigation.modules": "Other Modules",
        "backoffice.navigation.ownmodules": "Custom Modules",
        "backoffice.navigation.checkin": "Check-In App",
        "backoffice.navigation.forms": "Forms",
        "backoffice.navigation.pim": "E-Commerce",
        "backoffice.navigation.content": "Content",
        "backoffice.navigation.tasks": "Tasks",
        "backoffice.navigation.taskqueue": "Task Queue",
        "backoffice.navigation.applications": "Applications",
        "backoffice.navigation.favorites": "Favorites",
        "backoffice.navigation.members": "Co Workers",
        "backoffice.navigation.projectmembers": "Project Members",
        "backoffice.navigation.companymembers": "Company Members",
        "backoffice.navigation.servicetokens": "Servicetokens",
        "backoffice.navigation.customizationmode": "Customization Mode",
        "backoffice.topnav.addcompany": "Add company",
        "backoffice.topnav.showallcompanies": "To the company overview",
        "backoffice.topnav.showallprojects": "To the project overview",
        "backoffice.topnav.addproject": "Add project",
        "backoffice.topnav.myprofile": "My profile",
        "backoffice.topnav.messages": "My messages",
        "backoffice.topnav.mytasks": "My tasks",
        "backoffice.topnav.reseller": "Reseller Dashboard",
        "backoffice.topnav.logout": "Logout",
        "backoffice.topnav.companyprofile": "Company profile",
        "backoffice.footer.helplink": "Report a bug"
    };
}
exports.backofficeNavigation_en_us = backofficeNavigation_en_us;
